import { API_BASE_URL } from "../../../helpers/apiBaseUrl";

const token = () => {
  const value = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!value) return "";
  try { return JSON.parse(value); } catch { return value; }
};

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token()}`, ...options.headers },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) throw new Error(payload.message || payload.error || "Request failed.");
  return payload;
};

export const getDepartments = () => request("/departments");
export const getOrganisationUsers = () => request("/admins?size=500&status=1");
export const createDepartment = (data) => request("/departments", { method: "POST", body: JSON.stringify(data) });
export const updateDepartment = (id, data) => request(`/departments/${id}`, { method: "PUT", body: JSON.stringify(data) });
export const deleteDepartment = (id) => request(`/departments/${id}`, { method: "DELETE" });
export const createUnit = (data) => request("/units", { method: "POST", body: JSON.stringify(data) });
export const updateUnit = (id, data) => request(`/units/${id}`, { method: "PUT", body: JSON.stringify(data) });
export const deleteUnit = (id) => request(`/units/${id}`, { method: "DELETE" });
export const syncDepartmentMembers = (id, members) => request(`/departments/${id}/members`, { method: "PUT", body: JSON.stringify({ members }) });

export const toDepartmentView = (department) => ({
  id: department.id,
  name: department.name,
  description: department.description || "",
  hasUnits: !!department.has_units,
  status: department.status ? "Active" : "Inactive",
  head: department.hod_user?.name || "",
  headId: department.hod_user_id || null,
  approvalSkips: department.approval_skips || {},
  units: (department.units || []).map((unit) => ({
    id: unit.id,
    name: unit.name,
    description: unit.description || "",
    head: unit.head_user?.name || "",
    headId: unit.head_user_id || null,
    status: unit.status ? "Active" : "Inactive",
  })),
  members: (department.users || []).map((user) => ({
    id: user.id,
    name: user.name,
    email: user.email,
    units: (user.units || []).map((unit) => unit.name),
  })),
});
